<template>
  <div v-if="!!errors" class="error-info red-text">
    <i class="mfind-icon-x"></i>{{errors.join(', ')}}
  </div>
</template>

<script>
export default {
  props: ['errors']
}
</script>



// WEBPACK FOOTER //
// errorMessage.vue?1daf0aac